<wdpr-modal #createCastMemberModal close hide-close-icon disable-close-on-background>
  <h3 slot="title" class="header">Create Cast Member</h3>
  <div slot="body">
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="row">
        <div class="col-md-8">
          <div class="form-container">
            <label class="form-label" for="pernr">Pernr <span class="error">*</span></label>
            <wdpr-input id="pernr" class="form-input" type="number" formControlName="pernr" placeholder="Enter PERNR" (icon-button-click)="resetForm()" ngDefaultControl clearbutton></wdpr-input>
            <app-input-validation [formControl]="pernr" formLabel="Pernr" [submitted]="submitted" ngDefaultControl></app-input-validation>
          </div>
          <div class="form-container">
            <label class="form-label" for="site">Site <span class="error">*</span></label>
            <select id="site" name="site" formControlName="siteCode">
              <option [value]="''">Select Site</option>
              @for (option of siteOptions; track option) {
                <option [value]="option.value">
                  {{ option.text }}
                </option>
              }
            </select>
            <app-input-validation [formControl]="siteCode" formLabel="Site" [submitted]="submitted" ngDefaultControl></app-input-validation>
          </div>
          <div class="form-container">
            <label class="form-label" for="role">Role <span class="error">*</span></label>
            <select id="role" name="role" formControlName="role">
              <option [value]="''">Select Role</option>
              @for (option of roleOptions; track option) {
                <option [value]="option.text">
                  {{ option.text }}
                </option>
              }
            </select>
            <app-input-validation [formControl]="role" formLabel="Role" [submitted]="submitted" ngDefaultControl></app-input-validation>
          </div>
          <div class="form-container">
            <label class="form-label" for="gender">Gender <span class="error">*</span></label>
            <select id="gender" name="gender" formControlName="gender">
              @for (option of genderOptions; track option) {
                <option [value]="option.value">
                  {{ option.text }}
                </option>
              }
            </select>
            <app-input-validation [formControl]="gender" formLabel="Gender" [submitted]="submitted" ngDefaultControl></app-input-validation>
          </div>
        </div>
        <div class="col-md-4 ps-0">
          <wdpr-button class="search-button default" theme="inline-primary" [disabled]="pernr.invalid" (click)="onSearch()">Search</wdpr-button>
          @if (!isLoading && searched) {
            <!-- Allow user to continue -->
            @if (cast !== null) {
              <p class="warning-message">
                PERNR not found, continue to create Cast Member (fill up mandatory fields).
              </p>
            }
            <!-- PERNR not exist in DB and not exist in GUS+ -->
            @if (errCode === 404) {
              <p class="warning-message text-danger">
                PERNR is incorrect.
              </p>
            }
            <!-- PERNR exist in DB and not exist in GUS+ -->
            @if (errCode === 409) {
              <p class="warning-message text-danger">
                Measurements already exists for this Cast Member. Please use the search bar or enter a new PERNR.
              </p>
            }
          }
        </div>
      </div>
    </form>
  </div>
  <wdpr-button class="default me-0 ms-0" slot="buttons" theme="primary" (click)="onSubmit()" [disabled]="isContinueBtnDisabled">Continue</wdpr-button>
  <wdpr-button class="default me-2 ms-0" slot="buttons" theme="secondary" (click)="close()">Cancel</wdpr-button>
</wdpr-modal>
